module.exports = __webpack_public_path__ + "img/long-arrow-right.69042709.svg";